import { HStack, Text, VStack } from "@chakra-ui/react";
import { t } from "@lingui/macro";
import { Card } from "@src/components/ui-kit";
import { currency } from "@src/utils/formatters";
import type { FC } from "react";
import { useInvoiceDetailStore } from "../store";

type SummaryBoxProps = {
  label: string;
  description: string;
};

const SummaryBox: FC<SummaryBoxProps> = ({ label, description }) => {
  return (
    <Card minW="48" p="4">
      <VStack>
        <Text fontSize="xl" fontWeight="semibold">
          {label}
        </Text>
        <Text mt="3" color="grey" fontSize="xs">
          {description}
        </Text>
      </VStack>
    </Card>
  );
};

export const Summary = () => {
  const store = useInvoiceDetailStore();

  const work =
    store.invoice?.ourWorkBudgetSplits
      ?.map((split) => split.amount)
      .reduce((sum, current) => sum + current, 0) ?? 0;

  const expenses =
    store.invoice?.expenseBudgetSplits
      ?.map((split) => split.amount)
      .reduce((sum, current) => sum + current, 0) ?? 0;

  const prepayment =
    store.invoice?.prepaymentSplits
      ?.map((prepayment) => prepayment.amount)
      .reduce((sum, current) => sum + current, 0) ?? 0;

  return (
    <HStack justifyContent="flex-end" w="full" spacing="2">
      <SummaryBox
        label={currency.formatByWorkspace(work)}
        description={t`work`}
      />
      <SummaryBox
        label={currency.formatByWorkspace(expenses)}
        description={t`expenses`}
      />
      <SummaryBox
        label={currency.formatByWorkspace(prepayment)}
        description={t`prepayment`}
      />
    </HStack>
  );
};
